import { Button } from "@mui/material";
import { styled } from "@mui/system";
import config from "../../config";

const StyledButton = styled(Button)({
  position: "fixed",
  bottom: "16px",
  right: "16px",
  backgroundColor: "#000000",
  color: "white",
  textTransform: "unset",
  ":hover": {
    backgroundColor: "#000000",
  },
});

const TryWorkflow86Button = () => {
  return (
    <StyledButton
      variant="contained"
      target="_blank"
      href={config.MAIN_API_ADDRESS + "?ref=templates_page"}
    >
      Try Workflow86
    </StyledButton>
  );
};

export default TryWorkflow86Button;
